import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router"
import { NgxSpinnerService } from 'ngx-spinner';
import { IImage } from 'src/app/modules/slideshow/IImage';
import { environment } from 'src/environments/environment';
import { NgxNewstickerAlbeModule } from 'ngx-newsticker-albe';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']

})
export class HomeComponent {
  imageSources: (string | IImage)[] = [
    // { url: 'assets/img/slider/woohooSlider2.png',  href: '/channels' }
    // { url: 'assets/img/slider/kidsTube/fun.png',  href: '/channels' },
    // { url: 'assets/img/slider/kidsTube/learn.png',  href: '/channels' },
    // { url: 'assets/img/slider/kidsTube/explore.png',  href: '/channels' }
    // { url: 'assets/img/slider/glamourslide.png',  href: '/channel/16/explore'  },
    // { url: 'assets/img/slider/gamingslide.png',  href: '/channel/1/explore' },
    // { url: 'assets/img/slider/wildsideslide.png',  href: '/channel/2/explore' },
    // { url: 'assets/img/slider/kidsslide.png',  href: '/channel/6/explore' }
  ];
  siteID = environment.siteID;
  loaded: boolean = false;
  height: string = '321px';
  minHeight: string;
  banners: any = [];
  banner: any = [];
  arrowSize: string = '30px';
  celebrate: boolean = false;
  showArrows: boolean = true;
  disableSwiping: boolean = false;
  autoPlay: boolean = true;
  autoPlayInterval: number = 15000;
  stopAutoPlayOnSlide: boolean = true;
  debug: boolean = false;
  backgroundSize: string = 'cover';
  backgroundPosition: string = 'center center';
  backgroundRepeat: string = 'no-repeat';
  showDots: boolean = true;
  dotColor: string = '#FFF';
  renderStatic = environment.renderStatic;
  showCaptions: boolean = true;
  siteData: any = [];
  captionColor: string = '#FFF';
  isWoohoo: boolean =  environment['isWooHoo'];;;
  subscribedUser: boolean = false;
  captionBackground: string = 'rgba(0, 0, 0, .35)';
  lazyLoad: boolean = false;
  tickers: any = [];
  eventList: any = [];
  hideOnNoSlides: boolean = false;
  width: string = '100%';
  fullscreen: boolean = false;
  enableZoom: boolean = false;
  channels: any = [];
  enablePan: boolean = false;
  constructor(private spinner: NgxSpinnerService, public http: HttpClient, private router: Router) { this.site(), this.getBanners() }
  config = {
    autoHeight: true, speslidesPerView: 1,
    autoplay: { delay: 2000 },
    spaceBetween: 30,
    loop: true,
    breakpoints: {
      // when window width is <= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      // when window width is <= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      // when window width is <= 720px
      720: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      // when window width is <= 1000px
      1000: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  };
  editsubs: any = [];
  public site() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    let callURL = 'https://api-staging.videyo.tv/endpoint/getSite?siteID='+this.siteID
      if(this.renderStatic) {
        callURL = 'https://json.videyo.tv//'+this.siteID+'/getSite/fullData.json?salt='+(new Date().toISOString().slice(0,13))
      }
       this.http.get(callURL, {
      headers: myheader
    })
      .subscribe(
        dataholder => {
          let data = dataholder
          if(this.renderStatic) {
           data = dataholder['data']
          }
     this.subscribedUser = data['userSubscribedToSite'];
     this.subscribedUser = false;
     this.tickers  = data['tickers']
     this.tickers.forEach(ticker => {
      this.eventList.push(ticker['textBody'])
     });
        },
        error => {
        
        }
      );
  }
  refresh(): void {
    window.location.reload();
}
  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();
   
  }
  public getBanners() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    let callURL = 'https://staging.videyo.tv/endpoint/getSiteBanners?siteID='+this.siteID
    if(this.renderStatic) {
      callURL = 'https://json.videyo.tv//'+this.siteID+'/getSiteBanners/fullData.json?salt='+(new Date().toISOString().slice(0,13))
    }
     this.http.get(callURL, {
   headers: myheader
    })
      .subscribe(
        dataholder => {
          let data = dataholder
          if(this.renderStatic) {
           data = dataholder['data']
          }
          this.banners = data['banners'];
          this.banner = this.banners[Math.floor(Math.random() * this.banners.length)];
  console.log('banners')
  console.log(this.banners);
  console.log('banner')
  console.log(this.banner);
        },
        error => {
        
        }
      );
  }
  public siteBanners() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      let callURL = 'https://api-staging.videyo.tv/endpoint/getBannersForSite?siteID='+this.siteID
      if(this.renderStatic) {
        callURL = 'https://json.videyo.tv//'+this.siteID+'/getSiteContents/fullData.json?salt='+(new Date().toISOString().slice(0,13))
      }
       this.http.get(callURL, {
     headers: myheader
      })
      .subscribe(
        dataholder => {
          let data = dataholder
          if(this.renderStatic) {
           data = dataholder['data']
          }
          this.siteData = data;
          console.log('site data');
          console.log(this.siteData);
          for (let item of this.siteData) {
            if (item.channelID && !item.playlistID) {
              this.imageSources.push({ url: item.imageUrl, href: '/channel/' + item.channelID + '/explore' }, )
            }
            else if (item.playlistID && item.channelID) {
              this.imageSources.push({ url: item.imageUrl, href: '/playlist/' + item.channelID + '/' + item.playlistID + '/videos' }, )
            }
            else if (item.externalHttpUrl) {
              this.imageSources.push({ url: item.imageUrl, href: item.externalHttpUrl }, )

            }
          }
        },
        error => {

        }
      );
  }
  ngAfterViewInit() {
  }

  ngAfterViewChecked() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 2500);
  }
  
}